module.exports = __webpack_public_path__ + "img/undraw_Work_time_re_hdyv.a736c7d2.svg";